import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ApplyPopup = ({ onClose, job }) => {
  const qualifications = [
    "10th Standard",
    "12th Standard",
    "Diploma",
    "B.A",
    "B.Sc",
    "B.Com",
    "B.Tech",
    "B.E",
    "B.B.A",
    "B.C.A",
    "B.Ed",
    "B.Pharm",
    "B.Arch",
    "M.A",
    "M.Sc",
    "M.Com",
    "M.Tech",
    "M.E",
    "M.B.A",
    "M.C.A",
    "M.Ed",
    "M.Pharm",
    "PhD",
    "M.Phil",
    "CA",
    "CS",
    "ICWA",
    "LLB",
    "LLM",
    "Others"
  ];

  // Enhanced country codes with country names
  const countryCodes = [
    "+1 (United States)",
    "+1 (Canada)",
    "+7 (Russia)",
    "+7 (Kazakhstan)",
    "+20 (Egypt)",
    "+27 (South Africa)",
    "+30 (Greece)",
    "+31 (Netherlands)",
    "+32 (Belgium)",
    "+33 (France)",
    "+34 (Spain)",
    "+36 (Hungary)",
    "+39 (Italy)",
    "+40 (Romania)",
    "+41 (Switzerland)",
    "+43 (Austria)",
    "+44 (United Kingdom)",
    "+45 (Denmark)",
    "+46 (Sweden)",
    "+47 (Norway)",
    "+48 (Poland)",
    "+49 (Germany)",
    "+51 (Peru)",
    "+52 (Mexico)",
    "+53 (Cuba)",
    "+54 (Argentina)",
    "+55 (Brazil)",
    "+56 (Chile)",
    "+57 (Colombia)",
    "+58 (Venezuela)",
    "+60 (Malaysia)",
    "+61 (Australia)",
    "+62 (Indonesia)",
    "+63 (Philippines)",
    "+64 (New Zealand)",
    "+65 (Singapore)",
    "+66 (Thailand)",
    "+81 (Japan)",
    "+82 (South Korea)",
    "+84 (Vietnam)",
    "+86 (China)",
    "+90 (Turkey)",
    "+91 (India)",
    "+92 (Pakistan)",
    "+93 (Afghanistan)",
    "+94 (Sri Lanka)",
    "+95 (Myanmar)",
    "+98 (Iran)",
    "+212 (Morocco)",
    "+213 (Algeria)",
    "+216 (Tunisia)",
    "+218 (Libya)",
    "+220 (Gambia)",
    "+221 (Senegal)",
    "+222 (Mauritania)",
    "+223 (Mali)",
    "+224 (Guinea)",
    "+225 (Ivory Coast)",
    "+226 (Burkina Faso)",
    "+227 (Niger)",
    "+228 (Togo)",
    "+229 (Benin)",
    "+230 (Mauritius)",
    "+231 (Liberia)",
    "+232 (Sierra Leone)",
    "+233 (Ghana)",
    "+234 (Nigeria)",
    "+235 (Chad)",
    "+236 (Central African Republic)",
    "+237 (Cameroon)",
    "+238 (Cape Verde)",
    "+239 (Sao Tome and Principe)",
    "+240 (Equatorial Guinea)",
    "+241 (Gabon)",
    "+242 (Republic of the Congo)",
    "+243 (Democratic Republic of the Congo)",
    "+244 (Angola)",
    "+245 (Guinea-Bissau)",
    "+246 (British Indian Ocean Territory)",
    "+248 (Seychelles)",
    "+249 (Sudan)",
    "+250 (Rwanda)",
    "+251 (Ethiopia)",
    "+252 (Somalia)",
    "+253 (Djibouti)",
    "+254 (Kenya)",
    "+255 (Tanzania)",
    "+256 (Uganda)",
    "+257 (Burundi)",
    "+258 (Mozambique)",
    "+260 (Zambia)",
    "+261 (Madagascar)",
    "+262 (Reunion)",
    "+263 (Zimbabwe)",
    "+264 (Namibia)",
    "+265 (Malawi)",
    "+266 (Lesotho)",
    "+267 (Botswana)",
    "+268 (Eswatini)",
    "+269 (Comoros)",
    "+290 (Saint Helena)",
    "+291 (Eritrea)",
    "+297 (Aruba)",
    "+298 (Faroe Islands)",
    "+299 (Greenland)",
    "+350 (Gibraltar)",
    "+351 (Portugal)",
    "+352 (Luxembourg)",
    "+353 (Ireland)",
    "+354 (Iceland)",
    "+355 (Albania)",
    "+356 (Malta)",
    "+357 (Cyprus)",
    "+358 (Finland)",
    "+359 (Bulgaria)",
    "+370 (Lithuania)",
    "+371 (Latvia)",
    "+372 (Estonia)",
    "+373 (Moldova)",
    "+374 (Armenia)",
    "+375 (Belarus)",
    "+376 (Andorra)",
    "+377 (Monaco)",
    "+378 (San Marino)",
    "+380 (Ukraine)",
    "+381 (Serbia)",
    "+382 (Montenegro)",
    "+383 (Kosovo)",
    "+385 (Croatia)",
    "+386 (Slovenia)",
    "+387 (Bosnia and Herzegovina)",
    "+389 (North Macedonia)",
    "+420 (Czech Republic)",
    "+421 (Slovakia)",
    "+423 (Liechtenstein)",
    "+500 (Falkland Islands)",
    "+501 (Belize)",
    "+502 (Guatemala)",
    "+503 (El Salvador)",
    "+504 (Honduras)",
    "+505 (Nicaragua)",
    "+506 (Costa Rica)",
    "+507 (Panama)",
    "+508 (Saint Pierre and Miquelon)",
    "+509 (Haiti)",
    "+590 (Guadeloupe)",
    "+591 (Bolivia)",
    "+592 (Guyana)",
    "+593 (Ecuador)",
    "+594 (French Guiana)",
    "+595 (Paraguay)",
    "+596 (Martinique)",
    "+597 (Suriname)",
    "+598 (Uruguay)",
    "+599 (Netherlands Antilles)",
    "+670 (East Timor)",
    "+672 (Antarctica)",
    "+673 (Brunei)",
    "+674 (Nauru)",
    "+675 (Papua New Guinea)",
    "+676 (Tonga)",
    "+677 (Solomon Islands)",
    "+678 (Vanuatu)",
    "+679 (Fiji)",
    "+680 (Palau)",
    "+681 (Wallis and Futuna)",
    "+682 (Cook Islands)",
    "+683 (Niue)",
    "+684 (American Samoa)",
    "+685 (Samoa)",
    "+686 (Kiribati)",
    "+687 (New Caledonia)",
    "+688 (Tuvalu)",
    "+689 (French Polynesia)",
    "+690 (Tokelau)",
    "+691 (Micronesia)",
    "+692 (Marshall Islands)",
    "+850 (North Korea)",
    "+852 (Hong Kong)",
    "+853 (Macau)",
    "+855 (Cambodia)",
    "+856 (Laos)",
    "+880 (Bangladesh)",
    "+886 (Taiwan)",
    "+960 (Maldives)",
    "+961 (Lebanon)",
    "+962 (Jordan)",
    "+963 (Syria)",
    "+964 (Iraq)",
    "+965 (Kuwait)",
    "+966 (Saudi Arabia)",
    "+967 (Yemen)",
    "+968 (Oman)",
    "+970 (Palestine)",
    "+971 (United Arab Emirates)",
    "+972 (Israel)",
    "+973 (Bahrain)",
    "+974 (Qatar)",
    "+975 (Bhutan)",
    "+976 (Mongolia)",
    "+977 (Nepal)",
    "+992 (Tajikistan)",
    "+993 (Turkmenistan)",
    "+994 (Azerbaijan)",
    "+995 (Georgia)",
    "+996 (Kyrgyzstan)",
    "+998 (Uzbekistan)"
  ];

  const subBranches = {
  "Diploma": ["Engineering", "Arts", "Commerce", "Science", "Medical"],

  "B.Tech": ["Computer Science", "Information Technology", "Electronics & Communication", "Electrical", "Mechanical", "Civil", "Chemical", "Aerospace", "Biotechnology", "Automobile", "Artificial Intelligence", "Data Science"],

  "B.E": ["Computer Science", "Information Technology", "Electronics", "Electrical", "Mechanical", "Civil", "Chemical", "Aerospace", "Biotechnology"],

  "B.Sc": ["Physics", "Chemistry", "Mathematics", "Biology", "Computer Science", "Statistics", "Zoology", "Botany", "Electronics", "Others"],

  "B.A": ["English", "History", "Political Science", "Sociology", "Psychology", "Economics", "Philosophy", "Geography", "Public Administration"],

  "B.Com": ["General", "Accounting & Finance", "Banking & Insurance", "Taxation", "Computer Applications", "Business Analytics"],

  "BBA": ["General Management", "Finance", "Marketing", "Human Resource Management", "International Business", "Business Analytics"],

  "BCA": ["General", "Data Science", "Artificial Intelligence", "Cyber Security", "Cloud Computing", "Software Development"],

  "B.Ed": ["Science Education", "Mathematics Education", "Social Studies", "English", "Special Education"],

  "B.Pharm": ["Pharmaceutics", "Pharmacology", "Pharmaceutical Chemistry", "Pharmacognosy"],

  "B.Arch": ["Architecture", "Urban Design", "Landscape Architecture", "Interior Design"],

  "M.Tech": ["Computer Science", "Information Technology", "Electronics", "Electrical", "Mechanical", "Civil", "Chemical", "Aerospace", "Biotechnology", "Data Science", "AI/ML"],

  "M.E": ["Computer Science", "Mechanical", "Electrical", "Civil", "Electronics", "Chemical", "Biotechnology"],

  "M.Sc": ["Physics", "Chemistry", "Mathematics", "Biology", "Zoology", "Botany", "Statistics", "Computer Science", "Environmental Science"],

  "M.A": ["English", "History", "Political Science", "Sociology", "Psychology", "Economics", "Philosophy", "Geography", "Public Administration"],

  "M.Com": ["General", "Accounting & Finance", "Banking & Insurance", "Taxation", "Business Analytics"],

  "MBA": ["Finance", "Marketing", "Human Resource Management", "Operations", "International Business", "Entrepreneurship", "Business Analytics"],

  "MCA": ["General", "Data Science", "Artificial Intelligence", "Cyber Security", "Cloud Computing", "Software Development"],

  "M.Ed": ["Science Education", "Mathematics Education", "Social Studies", "English", "Special Education"],

  "M.Pharm": ["Pharmaceutics", "Pharmacology", "Pharmaceutical Chemistry", "Pharmacognosy"],

  "PhD": ["Computer Science", "Engineering", "Sciences", "Management", "Pharmacy", "Social Sciences", "Arts"],

  "M.Phil": ["Sciences", "Arts", "Commerce", "Education", "Management"],

  "LLB": ["General Law", "Criminal Law", "Corporate Law", "Constitutional Law", "Intellectual Property Law"],

  "LLM": ["Criminal Law", "Corporate Law", "Constitutional Law", "International Law", "Intellectual Property Law"],

  "CA": ["Accounting", "Auditing", "Taxation", "Corporate Finance"],

  "CS": ["Corporate Law", "Company Management", "Compliance", "Corporate Governance"],

  "ICWA": ["Cost Accounting", "Financial Management", "Corporate Finance", "Management Accounting"],

  "Others": ["General Studies", "Interdisciplinary Studies"]
};

  const [selectedSkills, setSelectedSkills] = useState([]);
  const [isPhysicallyChallenged, setIsPhysicallyChallenged] = useState("");
  const [disabilityType, setDisabilityType] = useState("");
  const [otherDisability, setOtherDisability] = useState("");
  const [resumeFile, setResumeFile] = useState(null);
  const [captchaChecked, setCaptchaChecked] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSubBranchDropdownOpen, setIsSubBranchDropdownOpen] = useState(false);
  const [isPhoneExtensionDropdownOpen, setIsPhoneExtensionDropdownOpen] = useState(false);
  const [isPassingYearDropdownOpen, setIsPassingYearDropdownOpen] = useState(false);
  const [isPriorExperienceDropdownOpen, setIsPriorExperienceDropdownOpen] = useState(false);
  const [isExEmployeeDropdownOpen, setIsExEmployeeDropdownOpen] = useState(false);
  const [isPhysicallyChallengedDropdownOpen, setIsPhysicallyChallengedDropdownOpen] = useState(false);
  const [timeoutIds, setTimeoutIds] = useState({});
  const [selectedPriorExperience, setSelectedPriorExperience] = useState("");
  const [priorExperienceSearchTerm, setPriorExperienceSearchTerm] = useState("");
  const [selectedQualification, setSelectedQualification] = useState("");
  const [subBranch, setSubBranch] = useState("");
  const [selectedSubBranch, setSelectedSubBranch] = useState("");
  const [customDegree, setCustomDegree] = useState("");
  // Added missing state variables for new dropdowns
  const [selectedExperience, setSelectedExperience] = useState("");
  const [experienceSearchTerm, setExperienceSearchTerm] = useState("");
  const [isExperienceDropdownOpen, setIsExperienceDropdownOpen] = useState(false);
  const [selectedExEmployee, setSelectedExEmployee] = useState("");
  const [exEmployeeSearchTerm, setExEmployeeSearchTerm] = useState("");
  const [selectedPhysicallyChallenged, setSelectedPhysicallyChallenged] = useState("");
  const [physicallyChallengedSearchTerm, setPhysicallyChallengedSearchTerm] = useState("");
  const [selectedDisabilityType, setSelectedDisabilityType] = useState("");
  const [disabilityTypeSearchTerm, setDisabilityTypeSearchTerm] = useState("");
  const [isDisabilityTypeDropdownOpen, setIsDisabilityTypeDropdownOpen] = useState(false);
  const [formData, setFormData] = useState({
    salutation: "", firstName: "", middleName: "", lastName: "", dob: "",
    phoneExtension: "", phone: "", email: "", location: "", exEmployee: "",
    companyName: "", designation: "", salary: "", passport: "", pan: "",
    notice: "", experience: "", qualification: "", university: "", passingYear: "",
    cgpa: "", certifications: "", preferredLocation: "", expectedSalary: "",
    preferredRole: "", jobType: "", relocate: "", languages: "", softSkills: "",
    linkedIn: "", portfolio: "", whyHire: "", coverLetter: "", subBranch: "", customDegree: "",
  });
  const [errors, setErrors] = useState({});

  // Helper functions for managing timeouts
  const setManagedTimeout = (key, callback, delay) => {
    // Clear existing timeout for this key
    if (timeoutIds[key]) {
      clearTimeout(timeoutIds[key]);
    }
    // Set new timeout and store its ID
    const timeoutId = setTimeout(() => {
      callback();
      // Remove the timeout ID after execution
      setTimeoutIds(prev => {
        const newIds = { ...prev };
        delete newIds[key];
        return newIds;
      });
    }, delay);
    setTimeoutIds(prev => ({ ...prev, [key]: timeoutId }));
  };

  const clearAllTimeouts = () => {
    Object.values(timeoutIds).forEach(timeoutId => {
      clearTimeout(timeoutId);
    });
    setTimeoutIds({});
  };

  // Cleanup timeouts on unmount
  React.useEffect(() => {
    return () => {
      clearAllTimeouts();
    };
  }, []);

  // Responsive dropdown styles for mobile and larger screens
  const dropdownBaseClass = "border p-2 rounded dropdown-card";
  const responsiveWidthClass = "w-full max-w-full sm:w-1/2 sm:max-w-[180px]";
  const responsiveFullWidthClass = "w-full max-w-full sm:w-full sm:max-w-[180px]";

  const toggleSkill = (skill) => {
    setSelectedSkills(prev =>
      prev.includes(skill) ? prev.filter(s => s !== skill) : [...prev, skill]
    );
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const err = {};
    if (!formData.salutation) err.salutation = "Required";
    if (!formData.firstName) err.firstName = "Required";
    if (!formData.lastName) err.lastName = "Required";
    if (!formData.qualification) err.qualification = "Required";
    if (selectedQualification && selectedQualification !== "Others" && subBranches[selectedQualification] && !subBranch) err.subBranch = "Required";
    if (selectedQualification === "Others" && !customDegree) err.customDegree = "Required";
    if (!formData.passingYear) err.passingYear = "Required";
    if (!formData.phoneExtension) err.phoneExtension = "Required";
    if (!formData.phone) err.phone = "Required";
    if (!formData.email) err.email = "Required";
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) err.email = "Invalid email format";
    if (!formData.exEmployee) err.exEmployee = "Required";
    if (!formData.priorExperience) err.priorExperience = "Required";
    if (formData.priorExperience === "Experienced") {
      if (!formData.experience) err.experience = "Required";
      if (!formData.companyName) err.companyName = "Required";
      if (!formData.notice) err.notice = "Required";
      if (!formData.salary) err.salary = "Required";
      if (!formData.expectedSalary) err.expectedSalary = "Required";
    }
    if (!resumeFile) err.resumeFile = "Resume is required";
    if (selectedSkills.length === 0) err.skills = "Select at least one skill";
    if (!captchaChecked) err.captcha = "Captcha is required";
    if (!isPhysicallyChallenged) err.physicallyChallenged = "Required";
    if (isPhysicallyChallenged === "Yes" && !disabilityType)
      err.disabilityType = "Please select a type";
    if (isPhysicallyChallenged === "Yes" && disabilityType === "Other" && !otherDisability)
      err.otherDisability = "Please specify disability";
    return err;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const tempErrors = validate();
    setErrors(tempErrors);
    if (Object.keys(tempErrors).length === 0) {
      const data = new FormData();

      // Append fields in the desired order
            data.append("01_salutation", formData.salutation);
            data.append("02_firstName", formData.firstName);
            data.append("03_lastName", formData.lastName);
            data.append("04_qualification", formData.qualification);
            if (selectedQualification && selectedQualification !== "Others" && subBranches[selectedQualification]) {
              data.append("05_subBranch", subBranch);
            } else if (selectedQualification === "Others") {
              data.append("05_customDegree", customDegree);
            }
            data.append("06_phoneExtension", formData.phoneExtension);
            data.append("07_phone", formData.phone);
            data.append("08_passingYear", formData.passingYear);
            data.append("09_priorExperience", formData.priorExperience);
            if (formData.priorExperience === "Experienced") {
              data.append("10_companyName", formData.companyName);
              data.append("11_experience", formData.experience);
              data.append("12_notice", formData.notice);
              data.append("13_salary", formData.salary);
              data.append("14_expectedSalary", formData.expectedSalary);
            }
            data.append("15_exEmployee", formData.exEmployee);
            if (formData.exEmployee === "Yes") {
              data.append("16_doj", formData.doj || "");
              data.append("17_doe", formData.doe || "");
              data.append("18_reasonForLeaving", formData.reasonForLeaving || "");
              data.append("19_employeeId", formData.employeeId || "");
              data.append("20_employeePosition", formData.employeePosition || "");
              data.append("21_reportingManager", formData.reportingManager || "");
              data.append("22_workLocation", formData.workLocation || "");
            }
            data.append("23_resume", resumeFile);
            data.append("24_selectedSkills", selectedSkills.join(", "));
            data.append("25_isPhysicallyChallenged", isPhysicallyChallenged);
            data.append("26_disabilityType", disabilityType);
            data.append("27_otherDisability", otherDisability);
            data.append("28_jobTitle", job.title);
            data.append("29_g-recaptcha-response", captchaChecked ? "verified" : "");

      try {
        await fetch("https://getform.io/f/bejlqgka", {
          method: "POST",
          body: data,
        });
        setSubmitted(true);
      } catch (err) {
        console.error(err);
        setErrors(prev => ({ ...prev, submit: "Submission failed" }));
      }
    }
  };

  if (submitted) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 p-4">
        <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-xl text-center">
          <h2 className="text-2xl font-semibold text-green-600 mb-4">Thank You for Applying!</h2>
          <p className="text-gray-700">Your application for <strong>{job.title}</strong> has been successfully submitted.</p>
          <button onClick={onClose} className="mt-6 text-blue-600 hover:underline font-medium">Close</button>
        </div>
      </div>
    );
  }

  return (
    <>
      <style>{`
      .dropdown-popup {
          box-sizing: border-box;
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
          border-radius: 0 0 0.5rem 0.5rem;
          max-height: 10rem;
          overflow-y: auto;
          background-color: white;
          width: 100%;
          max-width: 120px;
          z-index: 1000;
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
        }
        @media (min-width: 640px) {
          .dropdown-popup {
            max-width: 300px;
            width: 60%;
          }
        }
        @media (max-width: 639px) {
          .dropdown-popup {
            max-width: 100%;
            width: 100%;
            box-shadow: 0 2px 8px rgba(0,0,0,0.15);
          }
        }
        /* Custom style for exEmployee dropdown on iPhone XR and similar widths */
        @media (max-width: 414px) {
          select[name="exEmployee"] {
            padding: 0.25rem 0.5rem !important;
            max-width: 150px !important;
            font-size: 0.875rem !important;
          }
        }
      `}
      </style>
      <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-start z-50 overflow-y-auto p-4 pt-20">
        <div className="bg-white p-6 sm:p-8 rounded-xl w-full max-w-full sm:max-w-4xl max-h-[90vh] overflow-y-auto shadow-2xl">
          <h2 className="text-2xl font-semibold mb-6 text-center text-gray-800 break-words">Apply for {job.title}</h2>

          <form onSubmit={handleSubmit} encType="multipart/form-data" className="space-y-5">
            <div className="grid grid-cols-1 sm:grid-cols-[auto_1fr_1fr] gap-4 items-end">
              <div>
                <select name="salutation" value={formData.salutation} onChange={handleChange} className="border mt-6 p-2 w-24 max-w-[100px] rounded dropdown-card sm:w-24 sm:max-w-[100px]">
                  <option value="">Salutation</option>
                  <option value="Mr">Mr</option>
                  <option value="Ms">Ms</option>
                  <option value="Mrs">Mrs</option>
                </select>
                {errors.salutation && <p className="text-red-600 text-sm">{errors.salutation}</p>}
              </div>

            <div>
              <input name="firstName" value={formData.firstName} onChange={handleChange} type="text" placeholder="First Name *" className="border p-2 w-full rounded" />
              {errors.firstName && <p className="text-red-600 text-sm">{errors.firstName}</p>}
            </div>
            <div>
              <input name="lastName" value={formData.lastName} onChange={handleChange} type="text" placeholder="Last Name *" className="border p-2 w-full rounded" />
              {errors.lastName && <p className="text-red-600 text-sm">{errors.lastName}</p>}
            </div>
          </div>

          <div>
            <label className="font-medium">Highest Qualification <span className="text-red-500">*</span></label>
            <div className="relative">
              <input
                type="text"
                placeholder="Select Qualification"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setSelectedQualification("");
                  setIsDropdownOpen(true);
                }}
                onFocus={() => setIsDropdownOpen(true)}
                onBlur={() => setManagedTimeout('qualificationDropdown', () => setIsDropdownOpen(false), 200)}
                className="border mt-1 p-2 w-full rounded"
              />
              <span className="absolute right-2 top-3 text-gray-500">▼</span>
              {isDropdownOpen && (
  <ul className="dropdown-popup absolute z-10 bg-white border border-gray-300 max-h-40 overflow-y-auto rounded-b w-full sm:w-1/2 sm:max-w-[180px]">
    {qualifications.filter(q => q.toLowerCase().includes(searchTerm.toLowerCase())).map(q => (
      <li
        key={q}
        onMouseDown={(e) => {
          e.preventDefault(); // Prevent input blur before click
          setSelectedQualification(q);
          setFormData(prev => ({ ...prev, qualification: q }));
          setSearchTerm(q);
          setIsDropdownOpen(false);
          setSubBranch("");
          setCustomDegree("");
        }}
        className="p-2 hover:bg-gray-100 cursor-pointer"
      >
        {q}
      </li>
    ))}
  </ul>
)}
            </div>
            {errors.qualification && <p className="text-red-600 text-sm">{errors.qualification}</p>}
          </div>

{selectedQualification && selectedQualification !== "Others" && subBranches[selectedQualification] && (
            <div>
              <label className="font-medium">Sub-Branch <span className="text-red-500">*</span></label>
          <div className="relative">
              <input
              type="text"
              placeholder="Select Sub-Branch"
              value={subBranch}
              onChange={(e) => {
                setSubBranch(e.target.value);
                setSelectedSubBranch("");
                setFormData(prev => ({ ...prev, subBranch: e.target.value }));
                setIsSubBranchDropdownOpen(true);
              }}
              onFocus={() => setIsSubBranchDropdownOpen(true)}
              onBlur={() => setManagedTimeout('subBranchDropdown', () => setIsSubBranchDropdownOpen(false), 200)}
              className="border mt-1 p-2 w-full max-w-full rounded"
            />
            <span className="absolute right-2 top-3 text-gray-500 cursor-pointer" onClick={() => setIsSubBranchDropdownOpen(prev => !prev)}>▼</span>
            {isSubBranchDropdownOpen && (
  <ul className="dropdown-popup absolute z-10 bg-white border border-gray-300 max-h-40 overflow-y-auto rounded-b w-full">
    {subBranches[selectedQualification]
      .filter(sb => sb.toLowerCase().includes(subBranch.toLowerCase()))
      .map(sb => (
        <li
          key={sb}
          onMouseDown={(e) => {
            e.preventDefault(); // Prevent input blur before click
            setSubBranch(sb);
            setSelectedSubBranch(sb);
            setFormData(prev => ({ ...prev, subBranch: sb }));
            setIsSubBranchDropdownOpen(false);
          }}
          className="p-2 hover:bg-gray-100 cursor-pointer"
        >
          {sb}
        </li>
      ))}
  </ul>
)}
          </div>
              {errors.subBranch && <p className="text-red-600 text-sm">{errors.subBranch}</p>}
            </div>
          )}

          {selectedQualification === "Others" && (
            <div>
              <label className="font-medium">Specify Degree <span className="text-red-500">*</span></label>
              <input name="customDegree" value={customDegree} onChange={(e) => {
                setCustomDegree(e.target.value);
                setFormData(prev => ({ ...prev, customDegree: e.target.value }));
              }} type="text" placeholder="Enter your degree" className="border mt-1 p-2 w-full rounded" />
              {errors.customDegree && <p className="text-red-600 text-sm">{errors.customDegree}</p>}
            </div>
          )}

          {/* Row 1: Country Code and Phone Number */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-end">
            <div>
              <div className="relative">
                <div
                  tabIndex={0}
                  onBlur={(e) => {
                    // Check if the new focused element is inside this div
                    if (!e.currentTarget.contains(e.relatedTarget)) {
                      setIsPhoneExtensionDropdownOpen(false);
                    }
                  }}
                  className="relative"
                >
                  <input
                    type="text"
                    placeholder="Country Code"
                    value={formData.phoneExtension}
                    onChange={(e) => {
                      setFormData(prev => ({ ...prev, phoneExtension: e.target.value }));
                      setIsPhoneExtensionDropdownOpen(true);
                    }}
                    onFocus={() => setIsPhoneExtensionDropdownOpen(true)}
                    className="border p-2 w-full rounded"
                  />
                  <span className="absolute right-2 top-3 text-gray-500 cursor-pointer" onClick={() => setIsPhoneExtensionDropdownOpen(prev => !prev)}>▼</span>
                  {isPhoneExtensionDropdownOpen && (
                    <ul className="dropdown-popup absolute z-10 bg-white border border-gray-300 w-full max-h-40 overflow-y-auto rounded-b">
                      {countryCodes
                        .filter(code => code.toLowerCase().includes(formData.phoneExtension.toLowerCase()))
                        .map(code => (
                          <li
                            key={code}
                            onMouseDown={(e) => {
                              e.preventDefault(); // Prevent input blur before click
                              setFormData(prev => ({ ...prev, phoneExtension: code }));
                              setIsPhoneExtensionDropdownOpen(false);
                            }}
                            className="p-2 hover:bg-gray-100 cursor-pointer"
                          >
                            {code}
                          </li>
                        ))}
                    </ul>
                  )}
                </div>
              </div>
              {errors.phoneExtension && <p className="text-red-600 text-sm">{errors.phoneExtension}</p>}
            </div>
            <div>
              <input name="phone" value={formData.phone} onChange={handleChange} type="text" placeholder="Phone Number" className="border p-2 w-full rounded" />
              {errors.phone && <p className="text-red-600 text-sm">{errors.phone}</p>}
            </div>
          </div>

          {/* Row 2: Email and Year of Passing */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-end">
            <div>
              <input name="email" value={formData.email} onChange={handleChange} type="email" placeholder="Email Address *" className="border p-2 w-full rounded" />
              {errors.email && <p className="text-red-600 text-sm">{errors.email}</p>}
            </div>
            <div>
              <div
                tabIndex={0}
                onBlur={(e) => {
                  if (!e.currentTarget.contains(e.relatedTarget)) {
                    setIsPassingYearDropdownOpen(false);
                  }
                }}
                className="relative"
              >
                <input
                  type="text"
                  placeholder="Year of Passing"
                  value={formData.passingYear}
                  onChange={(e) => {
                    setFormData(prev => ({ ...prev, passingYear: e.target.value }));
                    setIsPassingYearDropdownOpen(true);
                  }}
                  onFocus={() => setIsPassingYearDropdownOpen(true)}
                  className="border mt-1 p-2 w-full rounded"
                />
                <span className="absolute right-2 top-3 text-gray-500 cursor-pointer" onClick={() => setIsPassingYearDropdownOpen(prev => !prev)}>▼</span>
                {isPassingYearDropdownOpen && (
                  <ul className="dropdown-popup absolute z-10 bg-white border border-gray-300 max-h-40 overflow-y-auto rounded-b w-full">
                    {Array.from({ length: new Date().getFullYear() - 1990 + 1 }, (_, i) => 1990 + i)
                      .reverse()
                      .filter(year => year.toString().includes(formData.passingYear))
                      .map(year => (
                        <li
                          key={year}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            setFormData(prev => ({ ...prev, passingYear: year.toString() }));
                            setIsPassingYearDropdownOpen(false);
                          }}
                          className="p-2 hover:bg-gray-100 cursor-pointer"
                        >
                          {year}
                        </li>
                      ))}
                  </ul>
                )}
              </div>
              {errors.passingYear && <p className="text-red-600 text-sm">{errors.passingYear}</p>}
            </div>
          </div>

          <div>
            <label className="font-medium">Prior Experience <span className="text-red-500">*</span></label>
            <div className="relative">
              <input
                type="text"
                placeholder="Select Experience"
                value={priorExperienceSearchTerm}
                onChange={(e) => {
                  setPriorExperienceSearchTerm(e.target.value);
                  setSelectedPriorExperience("");
                  setIsPriorExperienceDropdownOpen(true);
                }}
                onFocus={() => setIsPriorExperienceDropdownOpen(true)}
                onBlur={() => setManagedTimeout('priorExperienceDropdown', () => setIsPriorExperienceDropdownOpen(false), 200)}
                className="border mt-1 p-2 w-full rounded"
              />
              <span className="absolute right-2 top-3 text-gray-500">▼</span>
              {isPriorExperienceDropdownOpen && (
                <ul className="dropdown-popup absolute z-10 bg-white border border-gray-300 max-h-40 overflow-y-auto rounded-b w-full sm:w-1/2 sm:max-w-[180px]">
                  {["Fresher", "Experienced"].filter(exp => exp.toLowerCase().includes(priorExperienceSearchTerm.toLowerCase())).map(exp => (
                    <li
                      key={exp}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        setSelectedPriorExperience(exp);
                        setFormData(prev => ({ ...prev, priorExperience: exp }));
                        setPriorExperienceSearchTerm(exp);
                        setIsPriorExperienceDropdownOpen(false);
                      }}
                      className="p-2 hover:bg-gray-100 cursor-pointer"
                    >
                      {exp}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            {errors.priorExperience && <p className="text-red-600 text-sm">{errors.priorExperience}</p>}
{formData.priorExperience === "Experienced" && (
              <div className="space-y-4 mt-4 w-full">
                <div>
                  <label className="font-medium">Company Name <span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    name="companyName"
                    value={formData.companyName || ""}
                    onChange={handleChange}
                    placeholder="Company Name"
                    className="border p-2 w-full rounded"
                  />
                  {errors.companyName && <p className="text-red-600 text-sm">{errors.companyName}</p>}
                </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-start">
                <div className="form-field-container">
                  <label className="font-medium block mb-2">Years of Experience <span className="text-red-500">*</span></label>
                  <div className="relative">
                      <input
                        type="text"
                        placeholder="Select Years"
                        value={experienceSearchTerm}
                        onChange={(e) => {
                          setExperienceSearchTerm(e.target.value);
                          setSelectedExperience("");
                          setIsExperienceDropdownOpen(true);
                        }}
                        onFocus={() => setIsExperienceDropdownOpen(true)}
                        onBlur={() => setManagedTimeout('experienceDropdown', () => setIsExperienceDropdownOpen(false), 200)}
                        className="border p-2 w-full rounded"
                      />
                    <span className="absolute right-2 top-3 text-gray-500">▼</span>
                    {isExperienceDropdownOpen && (
                      <ul className="dropdown-popup absolute z-10 bg-white border border-gray-300 max-h-40 overflow-y-auto rounded-b w-full sm:w-1/2 sm:max-w-[180px]">
                        {["Less than 1", "1", "2", "3", "4", "5"].filter(opt => opt.toLowerCase().includes(experienceSearchTerm.toLowerCase())).map(opt => (
                          <li
                            key={opt}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              setSelectedExperience(opt);
                              setFormData(prev => ({ ...prev, experience: opt }));
                              setExperienceSearchTerm(opt);
                              setIsExperienceDropdownOpen(false);
                            }}
                            className="p-2 hover:bg-gray-100 cursor-pointer"
                          >
                            {opt}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  {errors.experience && <p className="text-red-600 text-sm">{errors.experience}</p>}
                </div>
                <div className="form-field-container">
                  <label className="font-medium block mb-2">Notice Period <span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    name="notice"
                    value={formData.notice || ""}
                    onChange={handleChange}
                    placeholder="Notice Period"
                    className="border p-2 w-full rounded"
                  />
                  {errors.notice && <p className="text-red-600 text-sm">{errors.notice}</p>}
                </div>
              </div>
                <div className="block md:flex md:space-x-4 space-y-4 md:space-y-0">
                  <div className="flex-1">
                    <label className="font-medium block mb-2">Current CTC <span className="text-red-500">*</span></label>
                    <input
                      type="text"
                      name="salary"
                      value={formData.salary || ""}
                      onChange={handleChange}
                      placeholder="Current CTC"
                      className="border p-2 w-full rounded"
                    />
                    {errors.salary && <p className="text-red-600 text-sm">{errors.salary}</p>}
                  </div>
                  <div className="flex-1">
                    <label className="font-medium block mb-2">Expected CTC <span className="text-red-500">*</span></label>
                    <input
                      type="text"
                      name="expectedSalary"
                      value={formData.expectedSalary || ""}
                      onChange={handleChange}
                      placeholder="Expected CTC"
                      className="border p-2 w-full rounded"
                    />
                    {errors.expectedSalary && <p className="text-red-600 text-sm">{errors.expectedSalary}</p>}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div>
            <label className="font-medium">Are you an Ex V Adithya Infinity Pvt Ltd? *</label>
            <div className="relative">
              <input
                type="text"
                placeholder="Select"
                value={exEmployeeSearchTerm}
                onChange={(e) => {
                  setExEmployeeSearchTerm(e.target.value);
                  setSelectedExEmployee("");
                  setIsExEmployeeDropdownOpen(true);
                }}
                onFocus={() => setIsExEmployeeDropdownOpen(true)}
                onBlur={() => setTimeout(() => setIsExEmployeeDropdownOpen(false), 200)}
                className="border p-2 w-full rounded"
              />
              <span className="absolute right-2 top-3 text-gray-500">▼</span>
              {isExEmployeeDropdownOpen && (
                <ul className="dropdown-popup absolute z-10 bg-white border border-gray-300 max-h-40 overflow-y-auto rounded-b w-full sm:w-1/2 sm:max-w-[180px]">
                  {["Yes", "No"].filter(opt => opt.toLowerCase().includes(exEmployeeSearchTerm.toLowerCase())).map(opt => (
                    <li
                      key={opt}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        setSelectedExEmployee(opt);
                        setFormData(prev => ({ ...prev, exEmployee: opt }));
                        setExEmployeeSearchTerm(opt);
                        setIsExEmployeeDropdownOpen(false);
                        if (opt === "No") {
                          setFormData((prev) => ({
                            ...prev,
                            doj: "",
                            doe: "",
                            reasonForLeaving: "",
                            employeeId: "",
                            employeePosition: "",
                            reportingManager: "",
                            workLocation: "",
                          }));
                        }
                      }}
                      className="p-2 hover:bg-gray-100 cursor-pointer"
                    >
                      {opt}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            {errors.exEmployee && <p className="text-red-600 text-sm">{errors.exEmployee}</p>}
          </div>
          {formData.exEmployee === "Yes" && (
            <div className="space-y-4 mt-4">
              <div className="space-y-2">
                <div className="grid grid-cols-2 gap-4">
                  <label className="font-semibold text-base text-gray-700 flex items-center">
                    Date of Joining (DOJ) <span className="text-red-500 ml-1">*</span>
                  </label>
                  <label className="font-semibold text-base text-gray-700 flex items-center">
                    Date of Exit (DOE) <span className="text-red-500 ml-1">*</span>
                  </label>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <DatePicker
                    selected={formData.doj ? new Date(formData.doj) : null}
                    onChange={(date) => {
                      setFormData(prev => ({ ...prev, doj: date ? date.toISOString().split('T')[0] : "" }));
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="dd-mm-yyyy"
                    className="border p-2 w-full rounded dropdown-card text-center font-medium text-gray-700"
                    popperPlacement="bottom-start"
                    popperProps={{
                      modifiers: [
                        {
                          name: 'offset',
                          options: {
                            offset: [0, 10],
                          },
                        },
                        {
                          name: 'preventOverflow',
                          options: {
                            rootBoundary: 'viewport',
                            tether: false,
                            altAxis: true,
                          },
                        },
                      ],
                    }}
                  />
                  <DatePicker
                    selected={formData.doe ? new Date(formData.doe) : null}
                    onChange={(date) => {
                      setFormData(prev => ({ ...prev, doe: date ? date.toISOString().split('T')[0] : "" }));
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="dd-mm-yyyy"
                    className="border p-2 w-full rounded dropdown-card text-center font-medium text-gray-700"
                    popperPlacement="bottom-start"
                    popperProps={{
                      modifiers: [
                        {
                          name: 'offset',
                          options: {
                            offset: [0, 10],
                          },
                        },
                        {
                          name: 'preventOverflow',
                          options: {
                            rootBoundary: 'viewport',
                            tether: false,
                            altAxis: true,
                          },
                        },
                      ],
                    }}
                  />
                </div>
              </div>
              <div>
                <label className="font-medium">Reason for Leaving <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  name="reasonForLeaving"
                  value={formData.reasonForLeaving || ""}
                  onChange={handleChange}
                  placeholder="Reason for Leaving"
                  className="border p-2 w-full rounded"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="font-medium">Employee ID <span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    name="employeeId"
                    value={formData.employeeId || ""}
                    onChange={handleChange}
                    placeholder="Employee ID"
                    className="border p-2 w-full rounded"
                  />
                </div>
                <div>
                  <label className="font-medium">Employee Position <span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    name="employeePosition"
                    value={formData.employeePosition || ""}
                    onChange={handleChange}
                    placeholder="Employee Position"
                    className="border p-2 w-full rounded"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label className="font-medium block mb-2 min-h-[2rem] flex items-start">Reporting Manager Name <span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    name="reportingManager"
                    value={formData.reportingManager || ""}
                    onChange={handleChange}
                    placeholder="Reporting Manager Name"
                    className="border p-2 w-full rounded"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-medium block mb-2 min-h-[2rem] flex items-start">Work Location <span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    name="workLocation"
                    value={formData.workLocation || ""}
                    onChange={handleChange}
                    placeholder="Work Location"
                    className="border p-2 w-full rounded"
                  />
                </div>
              </div>
            </div>
          )}

          <div>
            <label className="block font-medium">Upload Resume <span className="text-red-500">*</span></label>
            <input type="file" accept=".pdf,.doc,.docx" onChange={e => setResumeFile(e.target.files[0])} className="border p-2 w-full rounded" />
            {errors.resumeFile && <p className="text-red-600 text-sm">{errors.resumeFile}</p>}
          </div>

          <div>
            <label className="block font-medium">Skills You Know <span className="text-red-500">*</span></label>
            <div className="grid grid-cols-2 gap-2 mt-2 sm:grid-cols-3 sm:gap-3">
              {job.skills.map(skill => (
                <label key={skill} className="flex items-center space-x-2 text-sm sm:text-base">
                  <input type="checkbox" className="w-4 h-4 sm:w-5 sm:h-5" value={skill} checked={selectedSkills.includes(skill)} onChange={() => toggleSkill(skill)} />
                  <span>{skill}</span>
                </label>
              ))}
            </div>
            {errors.skills && <p className="text-red-600 text-sm">{errors.skills}</p>}
          </div>

          <div>
            <label className="font-medium">Physically Challenged <span className="text-red-500">*</span></label>
            <div className="relative">
              <input
                type="text"
                placeholder="-- Select --"
                value={physicallyChallengedSearchTerm}
                onChange={(e) => {
                  setPhysicallyChallengedSearchTerm(e.target.value);
                  setSelectedPhysicallyChallenged("");
                  setIsPhysicallyChallengedDropdownOpen(true);
                }}
                onFocus={() => setIsPhysicallyChallengedDropdownOpen(true)}
                onBlur={() => setManagedTimeout('physicallyChallengedDropdown', () => setIsPhysicallyChallengedDropdownOpen(false), 200)}
                className="border mt-1 p-2 w-full rounded"
              />
              <span className="absolute right-2 top-3 text-gray-500">▼</span>
              {isPhysicallyChallengedDropdownOpen && (
                <ul className="dropdown-popup absolute z-10 bg-white border border-gray-300 max-h-40 overflow-y-auto rounded-b w-full">
                  {["Yes", "No"].filter(opt => opt.toLowerCase().includes(physicallyChallengedSearchTerm.toLowerCase())).map(opt => (
                    <li
                      key={opt}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        setSelectedPhysicallyChallenged(opt);
                        setIsPhysicallyChallenged(opt);
                        setPhysicallyChallengedSearchTerm(opt);
                        setIsPhysicallyChallengedDropdownOpen(false);
                        setFormData(prev => ({ ...prev, isPhysicallyChallenged: opt }));
                        if (opt !== "Yes") {
                          setDisabilityType("");
                          setOtherDisability("");
                        }
                      }}
                      className="p-2 hover:bg-gray-100 cursor-pointer"
                    >
                      {opt}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            {errors.physicallyChallenged && <p className="text-red-600 text-sm">{errors.physicallyChallenged}</p>}

            {isPhysicallyChallenged === "Yes" && (
              <>
                <div className="relative mt-2">
                  <input
                    type="text"
                    placeholder="Select Disability Type"
                    value={disabilityTypeSearchTerm}
                    onChange={(e) => {
                      setDisabilityTypeSearchTerm(e.target.value);
                      setSelectedDisabilityType("");
                      setIsDisabilityTypeDropdownOpen(true);
                    }}
                    onFocus={() => setIsDisabilityTypeDropdownOpen(true)}
                    onBlur={() => setManagedTimeout('disabilityTypeDropdown', () => setIsDisabilityTypeDropdownOpen(false), 200)}
                    className="border p-2 w-full rounded dropdown-card"
                  />
                  <span className="absolute right-2 top-3 text-gray-500">▼</span>
                    {isDisabilityTypeDropdownOpen && (
                      <ul className="dropdown-popup absolute z-10 bg-white border border-gray-300 max-h-40 overflow-y-auto rounded-b w-full">
                        {["Vision", "Hearing", "Mobility", "Other"].filter(opt => opt.toLowerCase().includes(disabilityTypeSearchTerm.toLowerCase())).map(opt => (
                          <li
                            key={opt}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              setSelectedDisabilityType(opt);
                              setDisabilityType(opt);
                              setDisabilityTypeSearchTerm(opt);
                              setIsDisabilityTypeDropdownOpen(false);
                            }}
                            className="p-2 hover:bg-gray-100 cursor-pointer"
                          >
                            {opt}
                          </li>
                        ))}
                      </ul>
                    )}
                </div>
                {errors.disabilityType && <p className="text-red-600 text-sm">{errors.disabilityType}</p>}
                {disabilityType === "Other" && (
                    <input type="text" value={otherDisability} onChange={e => setOtherDisability(e.target.value)} placeholder="Please specify" className="border p-2 w-full rounded mt-2" />
                )}
                {errors.otherDisability && <p className="text-red-600 text-sm">{errors.otherDisability}</p>}
              </>
            )}
          </div>

          <div className="mt-4">
            <label className="block font-medium">Verify you're human <span className="text-red-500">*</span></label>
            <ReCAPTCHA sitekey="6LfhDIorAAAAAPfmASgvHJ-t-7NWQvUdbzRedc4j" onChange={() => setCaptchaChecked(true)} />
            {errors.captcha && <p className="text-red-600 text-sm">{errors.captcha}</p>}
          </div>

          <button type="submit" disabled={!captchaChecked} className={`w-full py-2 rounded text-white font-semibold transition ${captchaChecked ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"}`}>
            Submit Application
          </button>

          {errors.submit && <p className="text-red-600 text-center mt-3">{errors.submit}</p>}
        </form>

        <button onClick={onClose} className="mt-6 w-full text-center text-red-600 hover:underline font-medium">
          Cancel & Close
        </button>
      </div>
    </div>
    </>
  );
};

export default ApplyPopup;